import React, { useState, useEffect } from 'react';
import { useCore } from 'contexts/core';
import { useSelector } from 'react-redux';
import { getConflicts } from 'ducks/core';
import usePrevious from 'hooks/usePrevious';
import WarningIndicator from 'ui/WarningIndicator/WarningIndicator';
import { ProductEntity } from '@inter-ikea-storageone/range';

type Warning = {
  entityId: number;
  position: {
    x: number;
    y: number;
  };
};

const SceneConflicts = () => {
  const coreApi = useCore();
  const [warnings, setWarnings] = useState<Warning[]>([]);
  const conflicts = useSelector(getConflicts);
  const prevConflicts = usePrevious(conflicts);

  useEffect(() => {
    const updateWarnings = (entities: ProductEntity[]) => {
      const conflictIds = conflicts.map(c => c.entityId);
      const entitiesWithConflicts = entities.filter((entityInScene: any) =>
        conflictIds.includes(entityInScene.entityId)
      );

      const newWarnings = entitiesWithConflicts
        .map(({ entityId }) => coreApi.entities.getWithPositionById(entityId))
        .filter(Boolean) as NonNullable<ReturnType<typeof coreApi.entities.getWithPositionById>>[];

      setWarnings(newWarnings);
    };

    if (conflicts.length !== prevConflicts?.length) {
      updateWarnings(coreApi.entities.getAllProductEntities());
    }
    return coreApi.subscribe('update', updateWarnings);
  }, [conflicts, coreApi, prevConflicts]);

  useEffect(() => {
    coreApi.scene?.setSceneHasConflicts(conflicts.length > 0);
  }, [conflicts.length, coreApi]);

  return (
    <>
      {warnings.length > 0 &&
        warnings.map(({ entityId, position }) => (
          <WarningIndicator
            data-testid={`warning-indicator-${entityId}`}
            key={entityId}
            style={{ transform: `translate(${position.x}px, ${position.y}px)` }}
          />
        ))}
    </>
  );
};

export default SceneConflicts;
